import { render } from "./DocYookassaView.vue?vue&type=template&id=a65f7ac6"
import script from "./DocYookassaView.vue?vue&type=script&lang=js"
export * from "./DocYookassaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__